import * as React from 'react';

function SvgPmsPlaceholder(props) {
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M24 1.712l20 11.112v22.352L24 46.288 4 35.176V12.824L24 1.712zM8 17.792v15.03l14 7.78V25.204L8 17.792zM26 40.6l14-7.778v-15.03l-14 7.412V40.6zm-2-18.864L38.24 14.2 24 6.288l-14.24 7.91L24 21.74v-.004z"
        fill="#99B9FF"
      />
    </svg>
  );
}

export default SvgPmsPlaceholder;
